const colors = {
    black: '#000000',
    cabaret: '#cf5464',
    chinook: '#f5f4f4',
    doveGray: '#757575',
    gray: '#a8a8a8',
    gulfStream: '#75B3B2',
    harvestGold: '#eeeeee',
    irisBlue: '#00bcd4',
    lightGray: 'rgba(225,225,225,.2)',
    lochinvar: '#338b86',
    mossGreen: '#acdaae',
    orange: '#ffa500',
    platinateBlue: '#666666',
    primary: '#338b86',
    redOrange: '#f44336',
    secondary: '#ef4769',
    white: '#ffffff',
};

module.exports = {
    theme: {
        fontFamily: '"Lato", Helvetica, Arial, sans-serif',
        fontSize: 15,
        lineHeight: 1.65,
        app: {
            background: '#edecec',
        },
        actions: {
            true: colors.lochinvar,
            false: colors.redOrange,
            neutral: colors.doveGray,
        },
        palette: {
            accent1Color: colors.secondary,
            aluminium: '#999999',
            black: '#000000',
            blond: '#fdf3ba',
            cabaret: '#cf5464',
            chinook: '#a3cea5',
            colonialWhite: '#FFEEBA',
            darkOrange: '#ff8d05',
            deepCarminePink: '#f23a2f',
            desertStorm: '#f8f8f8',
            doveGray: '#757575',
            envy: '#8aab8b',
            gallery: '#efefef',
            gray: '#a8a8a8',
            gulfStream: '#75B3B2',
            harvestGold: '#eeeeee',
            irisBlue: '#00bcd4',
            lightGray: 'rgba(225,225,225,.2)',
            lochinvar: '#338b86',
            mossGreen: '#acdaae',
            offWhite: '#f9f9f9',
            orange: '#ffa500',
            pickerHeaderColor: '#338b86',
            pipi: '#FFF3CD',
            platinateBlue: '#666666',
            primary1Color: '#338b86',
            primary1ColorHover: '#005d59', // Dark
            primary2Color: '#005d59', // Dark
            primary2ColorHover: '#338885', // Darker
            primary3Color: '#4c9e9c', // Dark
            secondary: colors.primary,
            rangeBackgroundColor: 'lightblue',
            redOrange: '#f44336',
            silver: '#c0c0c0',
            springRain: '#99bd9b',
            stack: '#8e8e8e',
            stardust: '#a0a0a0',
            tomato: '#ff574b',
            white: '#ffffff',
            wildSand: '#f4f4f4',
            yukonGold: '#786600',
        },
        accordion: {
            border: 'rgb(224, 224, 224)',
            closed: colors.white,
            content: colors.white,
            highlight: '#f5f4f4',
            open: '#f5f4f4',
        },
        appBar: {
            color: '#338b86',
        },
        cards: {
            header: colors.harvestGold,
        },
        table: {
            head: {
                color: 'rgba(0, 0, 0, 0.87)',
                border: 'rgb(224, 224, 224)',
                background: colors.white,
                inactive: 'rgba(0, 0, 0, 0.6)',
            },
            body: {
                row: {
                    background: 'rgb(224, 224, 224)',
                    hover: 'rgba(224, 224, 224, 0.4)',
                    color: 'rgba(0, 0, 0, 0.87)',
                    border: 'rgb(224, 224, 224)',
                },
            },
        },
        tabs: {
            backgroundColor: colors.white,
            selectedTextColor: colors.irisBlue,
            textColor: '#757575',
        },
        inkBar: {
            backgroundColor: colors.irisBlue,
        },
        textField: {
            floatingLabelColor: colors.platinateBlue,
            disabledTextColor: colors.platinateBlue,
        },
        sidebar: {
            backgroundColor: '#4c9e9c',
        },
    },
    title: 'Mobian Dashboard',
};


// WEBPACK FOOTER //
// ./src/tenants/mobian/index.js